import { t } from 'i18next'
import { ListRequestParams } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { ABaseTableFilter } from './ABaseTableFilter'
import { FC } from 'react'

interface Props {
  listRequestParams: ListRequestParams
  updateFilterState: any
  endpoint?: string
  multiple?: boolean
  placeholder?: string
}

export const TeamsFilter: FC<Props> = ({
  listRequestParams,
  updateFilterState,
  endpoint,
  placeholder,
  multiple = true,
}) => {
  const url = endpoint || endpoints.teams()

  const commonProps = {
    onChange: (team) => updateFilterState({ team }),
    value: listRequestParams.filter.team,
    placeholder: placeholder ?? t('bid:filterByTeams'),
    getLabel: (label) => label.name,
    endpoint: url,
    showSearch: false,
    multiple,
    listHeight: 300, // Removed scrolling for one item
    id: 'teamsFilter',
  }

  return <ABaseTableFilter {...commonProps} />
}
